import { Component, OnInit, Input } from "@angular/core";
import { ServerService } from "../../shared/services/server.service";
import { FlatsInfo } from "../../shared/models/models";

@Component({
  selector: "app-toogle-obj",
  templateUrl: "./toogle-obj.component.html",
  styleUrls: ["./toogle-obj.component.scss"]
})
export class ToogleObjComponent implements OnInit {

  @Input() spotId: number;

  loadingFlatsInfo: boolean = false;
  itemsForFlats: FlatsInfo[];
  firstFlat: FlatsInfo;

  itemsForFlatsEx: FlatsInfo[];

  constructor(private server: ServerService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loadingFlatsInfo = true;
    this.server.getRealizationFlatSalesInfo(this.spotId).then(rest => {
      if (rest) {
        this.loadingFlatsInfo = false;
        this.itemsForFlats = rest.slice(1, rest.length);
        this.itemsForFlatsEx = this.itemsForFlats.filter(r => r.totalFlatCount > 0);
        this.firstFlat = rest[0];
      }
    });
  }

  reloadData(event) {
    if (event) {
      this.loadData();
    }
  }

}
